<script lang="ts">

	export let inShutterInside = {
		nbColumn: 1,
		title: "",
		text: ""
	};

</script>

<style lang="scss">

	.shutterInside {
		font-family: 'Borna-Medium';
		font-size: 13px;
		width: 100%;
		&__title {
			display: none;
			align-self: flex-start;
			margin: 0 0 30px 0;
			&__visible {
				display: block;
			}
		}
		& :global(strong) {
			font-family: "Borna-Bold";
		}
		& :global(a) {
			text-decoration: none;
			color: $color_black;
			&::before {
				content: "↘";
				padding: 0 4px 0 0;
			}
			&:hover {
				text-decoration: underline;
			}
		}
		& :global(ul) {
			list-style-type: "-  ";
			margin-block-start: 0;
			margin-block-end: 0;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			padding-inline-start: 13px;
		}
		& :global(h1) {
			display: block;
			font-size: 23px;
			margin-block-start: 0em;
			margin-block-end: 0.67em;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			font-weight: bold;
		}
		& :global(h3) {
			border: 1px solid $color_black;
			background-color: $color_grey;
			padding: 5px 10px 4px 10px;
			width: fit-content;
			font-size: 13px;
			font-family: "Borna-Bold";
			margin: 20px 0 5px 0;
		}
		&__twocols {
			columns: 1;
		}
		&__threecols {
			columns: 1;
		}
	}

	@include large {
		.shutterInside {
			font-size: 1.2vw;
			&__title {
				font-size: 1.2vw;
				margin: 0 0 2px 0;
			}
			&__twocols {
				columns: 2;
				column-gap: 30px;
			}
			&__threecols {
				columns: 3;
				column-gap: 30px;
			}
			& :global(h1) {
				display: block;
				font-size: 3vw;
				margin-block-start: 2px;
				margin-block-end: 2px;
				margin-inline-start: 0px;
				margin-inline-end: 0px;
				font-weight: bold;
			}
			& :global(h3) {
				font-size: 1.2vw;
			}
		}
	}

	@include xlarge {
		.shutterInside {
			font-size: 16px;
			&__title {
				font-size: 16px;
			}
			& :global(h1) {
				font-size: 45px;
			}
			& :global(h3) {
				font-size: 16px;
			}
		}
	}

</style>

<div class="dotline"></div>
<div class="shutterInside__title" class:shutterInside__title__visible={inShutterInside.title != ""}>{inShutterInside.title}</div>
<div class="shutterInside" class:shutterInside__twocols={inShutterInside.nbColumn == 2} class:shutterInside__threecols={inShutterInside.nbColumn == 3}>
	{@html inShutterInside.text}
</div>
